<template>
  <div class="home">
    <!-- <div class="banner" :class="[backgroundImg]"></div> -->
    <div class="container">
      <div class="left">
        <div
          class="left_item bg-color home-p-color"
          @click="toFestival()"
        >
          <p>{{ $t('common.p58') }}</p>
        </div>
        <div
          v-for="(item, index) in list"
          :key="index"
          class="left_item bg-color home-p-color"
          :class="{ highlight: item.id == id}"
          @click="updateData(item.id)"
        >
          <p>{{ item.name }}</p>
        </div>
      </div>
      <div>
        <div class="right bg-color home-p-color">
          <div class="upcoming">
            <h2 class="title">
              {{ upcomingList.title }}
            </h2>
            <div class="line" />
            <template v-if="upcomingList.intro">
              <p class="subtitle0">
                Introduction
              </p>
              <p><pre>{{ upcomingList.intro }}</pre></p>
            </template>

            <p class="subtitle1">
              {{ $t('common.p74') }}
            </p>
            <p>
              <span><img
                class="chip_img"
                src="/official/static/img/home/Chip.png"
                alt
              > {{ $t('common.p65') }}:</span>
              {{ upcomingList.startDate | format }} - {{ upcomingList.endDate | format }}
            </p>
            <p>
              <span><img
                class="chip_img"
                src="/official/static/img/home/Chip.png"
                alt
              > {{ $t('common.p76') }}:</span>
              {{ upcomingList.buyin }}
            </p>
            <p>
              <span><img
                class="chip_img"
                src="/official/static/img/home/Chip.png"
                alt
              > {{ $t('common.p77') }}:</span>
              {{ upcomingList.gtd_prize }}
            </p>
            <p>
              <span><img
                class="chip_img"
                src="/official/static/img/home/Chip.png"
                alt
              > {{ $t('common.p78') }}:</span>
              {{ upcomingList.city }}
            </p>
            <p>
              <span><img
                class="chip_img"
                src="/official/static/img/home/Chip.png"
                alt
              > Venue:</span>
              {{ upcomingList.venue }}
            </p>
            <p class="subtitle2">
              {{ $t('common.p79') }}
            </p>

            <img
              v-if="upcomingList.schedule.pc"
              class="image"
              :src="upcomingList.schedule.pc"
              alt=""
            >
            <p v-else>
              {{ $t('common.p59') }}
            </p>

            <template v-if="upcomingList.competition">
              <p class="subtitle3">
                {{ $t('common.p80') }}
              </p>
              <a
                class="structure"
                target="_blank"
                :href="upcomingList.competition"
              >{{ upcomingList.competition.substring(upcomingList.competition.indexOf('official-website/') + 17) }}</a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getFestivalPreviewMatch } from '@/api/official'
import moment from 'moment'

export default {
  filters: {
    format: function (date) {
      return moment(date).format('MMM D, YYYY')
    }
  },
  data () {
    return {
      list: [],
      game: {},
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      light: {
        taiwan: {},
        japan: {}
      },
      backgroundImg: '',
      // mobileImg: '',
      atlas: [],
      bigAtlas: [],
      city: '',
      id: 1,
      upcomingList: {
        schedule: {},
        competition: ''
      }
    }
  },
  created () {
    this.id = this.$route.params.id
    this.$store.commit('changeTab', '/events')
    this.initData()
  },
  mounted () {
    document.querySelector('#app').scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    initData: function () {
      getFestivalPreviewMatch({ id: this.$route.params.id }).then(res => {
        this.upcomingList = res.data.list.map(v => {
          return {
            ...v,
            title: v.lang[this.$i18n.locale],
            intro: v.intro[this.$i18n.locale],
          }
        })[0]
      })

      getFestivalPreviewMatch().then(res => {
        this.list = res.data.list.map(v => {
          return { name: v.lang[this.$i18n.locale], id: v.id }
        })
      })
    },
    updateData (id) {
      // this.$router.push({ name: 'festival-upcoming', params: { id } })
      // this.id = id
      // this.initData()
      window.open('/festival/upcoming/' + id)
    },
    toFestival () {
      this.$router.push({ name: 'festival' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  padding: 65px 0px 65px 0px;
  min-width: 1200px;
  // .banner {
  //   background-repeat: no-repeat;
  //   background-size: cover;
  //   background-position: top;
  //   margin: 0;
  //   height: 410px;
  //   background-image: url("/official/static/img/festival_city/pc_japan.jpg");
  //   margin-bottom: 50px;
  // }
  .container {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
  }
  .left {
    position: relative;
    display: inline-block;
    width: 224px;
    .left_item {
      width: 200px;
      padding: 0 10px;
      height: 55px;
      margin-bottom: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      p {
        font-size: 15px;
        text-align: center;
        max-width:100%;
      }
    }
    .highlight {
      background-color: #58b26d;
      color: #fff;
    }
  }
  .right {
    position: relative;
    width: 868px;
    display: inline-block;
    padding: 52px 44px;
    .upcoming {
      // padding: 24px 24px 40px 24px;
      .chip_img {
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
        margin-bottom: 2px;
      }
      .title {
        font-size: 32px;
        color: #279754;
        margin: 0px 0px 16px 0px;
      }
      .line {
        border-top: 1px solid #bebebe;
        margin-bottom: 0px;
      }
      .image {
        display: block;
        width: 100%;
      }
      .subtitle0,
      .subtitle1,
      .subtitle2,
      .subtitle3 {
        font-size: 30px;
        margin-top: 30px;
        color: #666;
      }
      .subtitle0 {
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .subtitle1 {
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .subtitle2 {
        margin-bottom: 30px;
      }
      .subtitle3 {
        margin-bottom: 10px;
      }
      .structure {
        color: #1f9d56;
        // font-size: 24px;
        // box-shadow: 0 1px;
        text-decoration: underline;
        vertical-align: top;
      }
      p {
        font-size: 16px;
        line-height: 30px;
        // color: #9f9f9f;
        pre {
          font-size: 16px;
          line-height: 24px;
        }
        span {
          // font-size: 24px;
          // color: #9f9f9f;
          // color: #666;
        }
      }
    }
  }
}
</style>
